import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import "./table.scss";
import { cleanString } from "oj-utils";
export class Table extends MithrilTsxComponent {
    row;
    view(v) {
        return m("div", { className: cleanString("Table", v.attrs.className), style: { "--cols": v.attrs.headers.map(x => x.size).join(" ") } },
            v.attrs.headers.map(header => m("div", { className: "cell header", style: { justifyContent: header.align } }, header.label)),
            v.attrs.rows.map((row, rowIndex) => {
                const className = v.attrs.rowClassName?.(row);
                return v.attrs.headers.map(header => {
                    const c = header.view ? header.view(row) : row[header.key];
                    const id = header.id?.(row) ?? `${header.key}-${rowIndex}`;
                    return m("div", { key: id, id: id, className: cleanString("cell", `row-${rowIndex}`, className, rowIndex % 2 === 0 ? "even" : "odd", (c == undefined || c == false) && "empty", header.className?.(row), v.attrs.onrowclick && "clickable", this.row === row && "hover"), style: { justifyContent: header.align }, onclick: v.attrs.onrowclick ? (e => v.attrs.onrowclick(e, row, rowIndex)) : undefined, onpointerenter: () => this.row = row, onpointerleave: () => delete this.row }, c);
                });
            }));
    }
}
